export default __webpack_public_path__ + "static/media/cyto-logo-250x75.b558c645.jpg";